import pickFP from 'lodash/fp/pick';

const pickFromCountry = pickFP(['id']);

const prepareCountries = () => (country) => ({
  ...pickFromCountry(country),
  type: 'country',
  name: country.name_ru,
  text: country.name_ru,
  code: country.iso2,
});

const MOST_POPULAR_LIST_LENGTH = 7;
const hasPriorityField = (c) => c.priority;
const prioritySorter = (a, b) => b.priority - a.priority;
const getMostPopularList = (countries) =>
  countries
    .filter(hasPriorityField)
    .sort(prioritySorter)
    .slice(0, MOST_POPULAR_LIST_LENGTH)
    .map(prepareCountries());

const alphabeticalSorter = (a, b) => a.name_ru.localeCompare(b.name_ru);
const getAlphabeticalList = (countries) =>
  countries.sort(alphabeticalSorter).map(prepareCountries());

export default (countries) => {
  const countriesList = [];
  const activeCountries = countries.filter((c) => c.active);

  const mostPopularList = getMostPopularList(activeCountries);
  const alphabeticalList = getAlphabeticalList(activeCountries);

  const popularIds = mostPopularList.map((item) => item.id);
  const uniqAlphabeticalList = alphabeticalList.filter((item) => !popularIds.includes(item.id));

  if (mostPopularList.length) {
    countriesList.push(
      {
        isGroup: true,
        type: 'country',
        groupSlug: 'Самые популярные страны',
      },
      ...mostPopularList
    );
  }

  if (uniqAlphabeticalList.length) {
    countriesList.push(
      {
        isGroup: true,
        type: 'country',
      },
      ...uniqAlphabeticalList
    );
  }

  return countriesList;
};
